import React from "react";
import { IMG } from "../../asset";

export default function Partners() {
  return (
    <div className="w-full h-[72vh] md:h-auto flex items-start">
      <img src={IMG.partners} alt="partners" className="w-full object-contain" />
    </div>
  );
}
